import { render, staticRenderFns } from "./RelatorioFornecedor.vue?vue&type=template&id=238e0fa3&"
import script from "./RelatorioFornecedor.vue?vue&type=script&lang=js&"
export * from "./RelatorioFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports